import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "w-100 position-relative",
  style: {"height":"400px","border":"1px solid #adb5bd","border-radius":"5px","overflow-y":"auto"}
}
const _hoisted_2 = {
  key: 0,
  class: "accounts-loading h-100"
}
const _hoisted_3 = { class: "d-flex justify-center mt-1" }
const _hoisted_4 = {
  style: {"font-weight":"bold","font-size":"14px"},
  class: "pt-2"
}

import roleAssignAccountType from "@/types/responses/roleAssignAccount"
import organizationType from "@/types/requests/organizationType"
import { computed } from "vue"
import i18n from "@/lang/i18n"


export default /*@__PURE__*/_defineComponent({
  __name: 'ElementPersonInCharge',
  props: {
    title: {},
    accounts: {},
    modelValue: {},
    alreadyAssignedAccountIds: {},
    organizations: {},
    displayIcon: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const organization = computed(() => (account: roleAssignAccountType) => {
  return props.organizations.find((organization: organizationType) => {
    return organization.type == account.officeable_type && organization.id == account.officeable_id
  })?.name
})

const accountFindIndex = computed(() => (account: roleAssignAccountType) => {
  return modelValue.value.findIndex((value) => value.id === account.id)
})

const isSelected = computed(() => (account: roleAssignAccountType, index: number) => {
  const accountIndex = accountFindIndex.value(account)
  if (accountIndex === -1) {
    return {
      backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff'
    }
  }
  return {
    backgroundColor: '#007bff',
    color: '#ffffff'
  }
})

const displayEmail = computed(() => (account: roleAssignAccountType) => {
  const originalEmail = account.email ?? ''
  if (!originalEmail) return originalEmail
  const domain = originalEmail.split('@')[1]
  return `${originalEmail.slice(0, 3)}***@${domain}`
})

function addOrdelete(account: roleAssignAccountType) {
  const accountIndex = accountFindIndex.value(account)
  if (accountIndex === -1) {
    modelValue.value.push(account)
  } else {
    modelValue.value.splice(accountIndex, 1)
  }
}

function isAlreadyAssigned(account: roleAssignAccountType) {
  if (!props.displayIcon) return true
  return !!props.alreadyAssignedAccountIds?.find((id: number) => {
    return id == account.id
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h6", _hoisted_4, _toDisplayString(props.title), 1)
    ]),
    _createVNode(_component_v_row, {
      class: "mx-3 mt-6",
      style: {"border-bottom":"1px solid #adb5bd"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "1" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.header.id')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.header.organization')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.header.userName')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.header.email')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.accounts, (account, index) => {
      return (_openBlock(), _createBlock(_component_v_row, {
        key: index,
        value: account,
        class: "mx-3",
        style: _normalizeStyle(isSelected.value(account, index)),
        onClick: ($event: any) => (addOrdelete(account)),
        role: "button"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "1" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(account.id), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(organization.value(account)), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_col, {
            cols: "4",
            style: {"word-break":"break-all"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(account.full_name), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_col, {
            cols: "4",
            style: {"word-break":"break-all"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(displayEmail.value(account)) + " ", 1),
              (props.displayIcon && !isAlreadyAssigned(account))
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    icon: "mdi-new-box"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["value", "style", "onClick"]))
    }), 128))
  ]))
}
}

})